var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.12795 12.7331C1.67173 9.76757 1.2155 6.80215 0.75928 3.83665C0.658105 3.17927 1.40608 2.73092 1.93813 3.13C3.35953 4.19605 4.78085 5.26202 6.20225 6.32807C6.67025 6.67907 7.337 6.56485 7.66145 6.0781L11.2114 0.753098C11.5866 0.190373 12.4134 0.190373 12.7885 0.753098L16.3385 6.0781C16.663 6.56485 17.3297 6.679 17.7977 6.32807C19.2191 5.26202 20.6404 4.19605 22.0618 3.13C22.5939 2.73092 23.3419 3.17927 23.2408 3.83665C22.7845 6.80215 22.3283 9.76757 21.8721 12.7331H2.12795Z",
    fill: "#F07651"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8436 17.669H3.15828C2.58978 17.669 2.12891 17.2082 2.12891 16.6397V14.3784H21.873V16.6397C21.873 17.2082 21.4121 17.669 20.8436 17.669Z",
    fill: "#F07651"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKingIcon);
export default __webpack_public_path__ + "static/media/king-icon.4f0a59af2320d332cc244fa792813454.svg";
export { ForwardRef as ReactComponent };